import Picture from '../picture'

interface Props {
  heading: string
  value: string
  image: string
}

const FeatureCard = ({ heading, value, image }: Props) => (
  <article className="md:my-6 my-2 flex flex-col items-center justify-center rounded-2xl transition-transform duration-300 hover:scale-105 pt-6 pb-[26px] md:h-60 md:max-w-[360px] w-full border-[#E2E2E3] shadow-[#E2E2E3] border hover:shadow-xl">
    <Picture
      image={image}
      imageAlt={heading}
      aria-hidden="true"
      role="presentation"
      imageStyle="aspect-square md:w-[100px] w-[72px]"
    />
    <p className="mt-2 text-base text-[#2f2f2f] leading-[1.42] font-natosans-semibold text-center">
      {heading}
    </p>
    <p className="mt-2 text-2xl text-[#101010] leading-[27px] font-natosans-bold">
      {value}
    </p>
  </article>
)

export default FeatureCard
